<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Payout Partner Bank List</div>
        <div>
          <bread-crumb :bread-crumbs="['Payout Partner Bank Summary']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <!-- <v-toolbar flat dense>
        <v-toolbar-title>Payout Partner Bank List</v-toolbar-title>
      </v-toolbar> -->
      <!-- <v-divider></v-divider> -->
      <v-card-text>
      <v-row class="ms-1 me-1 mt-2">
        <v-col cols="12" md="2" lg="2" xs="12">
          <!-- <label class="required labelFontsize   my-0"> Location Name </label> -->
          <v-text-field
            class=""
            dense
            outlined
            placeholder="Location Name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" lg="2" xs="12">
          <!-- <label class="required labelFontsize   my-0"> Country</label> -->
          <v-autocomplete
            class=""
            dense
            outlined
            placeholder="Select Country"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" lg="2" xs="12">
          <!-- <label class="required labelFontsize   my-0">
            Payout Partner
          </label> -->
          <v-autocomplete
            class=""
            dense
            outlined
            placeholder="Select Payout Partner"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" lg="2" xs="12">
          <!-- <label class="required labelFontsize   my-0"> Payment Type</label> -->
          <v-autocomplete
            class=""
            dense
            outlined
            placeholder="Select Payment Type"
          ></v-autocomplete>
        </v-col>
        <div class="d-flex">
          <v-btn depressed  small class=" text-capitalize" color="primary"
            >Search</v-btn
          ><v-btn depressed  class="ms-3 text-capitalize" small color="primary" outlined
            >New</v-btn
          >
        </div>
      </v-row>
      <v-row class="mb-5">
        <v-col cols="12" md="4" lg="4" xs="12">
          <v-btn depressed  @click="downloadExcelsheet" color="primary" small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        </v-col>
        <v-col cols="12" md="4" lg="5" xs="12"></v-col>
        <v-col cols="12" md="4" lg="3" xs="12"
          ><v-text-field
            v-model="search"
            single-line
            label="Type here to search the table data."
            hide-details
            class="me-4"
            dense
            clearable
          ></v-text-field
        ></v-col>
      </v-row>
      <v-data-table fixed-header  height="55vh" :headers="headers" :items="desserts" dense class="mt-6">
        <template v-slot:item.actions="{ item }">
          <v-icon small color="primary" class="mr-2" @click="editItem(item)">
            mdi-trash-can-outline
          </v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "Payout Partner Bank Summary",
  components: {
    BreadCrumb,
  },
  data: () => {
    return {
      headers: [
        { text: "Country", value: "Country" },
        { text: "Location Name", value: "Location_Name" },
        { text: "External Bank ID", value: "External_Bank_ID" },
        { text: "Payment Type", value: "Payment_Type" },
        { text: "Payout Partner", value: "Payout_Partner" },
        { text: "Branch", value: "Branch" },
        { text: "Delete", value: "actions" },
      ],
      desserts: [
        {
          Country: "Bangladesh",
          Location_Name: "Agrani Bank",
          External_Bank_ID: "BA17",
          Payment_Type: "Bank Transfer",
          Payout_Partner: "Tranglo Nepal",
          Branch: "Branch",
          Delete: "",
        },
      ],
    };
  },
  methods: {
    async downloadExcelsheet() {
      if (this.desserts) {
        this.exportToExcel(this.headers, this.desserts, "payout Partner");
      }
    },
  }
};
</script>
<style scoped  lang="scss">
@import "@/global.scss";
</style>
